/**
 * Created by razial on 18.09.2026.
 */

Mission.TYPE_LEVELPASS = 15;

Forces.LEVELPASS = {
    id: 45,
    text: "LevelPass.force"
};

Mission.REGISTRATIONS.set(Mission.TYPE_LEVELPASS, () => ({
    ...BaseMissionData(),
    priority: 4,
    name: "LevelPass",
    view: LevelPassWindow,
    semaphore: Mission.SEMAPHORE_PRIMARY,
    iconForce: Forces.LEVELPASS,
    startWindow: LevelPassWindow,
    finishWindow: LevelPassWindow,
    guideWindow: {
        name: "PassRulesWindow",
        bundle: bundles.passruleswindow
    },
    logic: PassMissionLogic,
    levels: PassLevelsConfig.levelpass,
    sideBarJson: bundles.sidebar.jsons.levelpass_icon_json,
    sideBarProgressIconJson: bundles.sidebar.jsons.levelpass_star_json,
    lastChanceView: PassLastChanceWindow,
    collectIcon: function () {
        return cleverapps.skins.getSlot("pass_star_png") || bundles.reward_icons_pass.frames.pass_star_png;
    },
    collectItemName: "star",
    duration: "7 days",
    available: cleverapps.config.availables.LEVELPASS_MISSION
}));
